import { DeliveryAnalyticsAggregatesSchema } from "@redotech/redo-analytics-common/analytics";
import * as z from "zod";

export const getDeliveryAnalyticsAggregates = {
  name: "getDeliveryAnalyticsAggregates",
  input: z.object({ numUnits: z.number().positive(), startDate: z.date() }),
  output: DeliveryAnalyticsAggregatesSchema,
};
